<template>
  <div class="">
    <nav-bar :navigationIndex="5" />



  </div>
</template>
<script setup>
import { ref, reactive } from "vue"




</script>
<style lang="scss" scoped></style>
